import React from 'react'

export default function BankIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width={18}
            height={18}
            x={0}
            y={0}
            viewBox="0 0 64 64"
            style={{ enableBackground: "new 0 0 64 64" }}
            xmlSpace="preserve"
        >
            <path
                d="M32 4 L2 20 v4 h60 v-4 L32 4 z M8 28 v22 h6 V28 H8 z M22 28 v22 h6 V28 h-6 z M36 28 v22 h6 V28 h-6 z M50 28 v22 h6 V28 h-6 z M2 52 v8 h60 v-8 H2 z"
                fill="currentcolor"
            />
        </svg>
    )
}
